import React, { useState, useEffect } from 'react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Colors based on brand guidelines
  const colors = {
    primary: "#122721",
    background: "#6cf168",
    white: "#ffffff"
  };

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Smooth scroll with navbar offset
  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      const navbarHeight = 80; // Approximate navbar height
      const targetPosition = target.offsetTop - navbarHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled 
          ? 'py-4 backdrop-blur-lg bg-white/80 shadow-md' 
          : 'py-4 bg-transparent'
      }`}
    >
      {/* Import DM Sans font for ARBAAH branding */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@1,700&display=swap');
      `}</style>
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="text-5xl font-bold" style={{ 
              color: colors.primary,
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: 700,
              fontStyle: 'italic',
              letterSpacing: "-0.14em"
            }}>
              Arbaah
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#benefits"
              onClick={(e) => handleNavClick(e, '#benefits')}
              className="font-medium hover:opacity-80 transition-opacity cursor-pointer"
              style={{ color: colors.primary }}
            >
              Benefits
            </a>
            <a
              href="#pricing"
              onClick={(e) => handleNavClick(e, '#pricing')}
              className="font-medium hover:opacity-80 transition-opacity cursor-pointer"
              style={{ color: colors.primary }}
            >
              Pricing
            </a>
            <a
              href="#testimonials"
              onClick={(e) => handleNavClick(e, '#testimonials')}
              className="font-medium hover:opacity-80 transition-opacity cursor-pointer"
              style={{ color: colors.primary }}
            >
              Testimonials
            </a>
                <a
              href="#faq"
              onClick={(e) => handleNavClick(e, '#faq')}
              className="font-medium hover:opacity-80 transition-opacity cursor-pointer"
              style={{ color: colors.primary }}
            >
              FAQ
            </a>
            <a 
              href="https://app.arbaah.ae/authentication/sign-in" 
              className="font-medium hover:opacity-80 transition-opacity"
              style={{ color: colors.primary }}
            >
              Login
            </a>
            <a 
              href="https://app.arbaah.ae/authentication/sign-up" 
              className="px-4 py-2 rounded-full text-white font-medium hover:opacity-90 transition-opacity"
              style={{ backgroundColor: colors.primary }}
            >
              Get Started
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-2 rounded-md focus:outline-none"
              style={{ color: colors.primary }}
            >
              {mobileMenuOpen ? (
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="h-6 w-6" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M6 18L18 6M6 6l12 12" 
                  />
                </svg>
              ) : (
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="h-6 w-6" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M4 6h16M4 12h16m-7 6h7" 
                  />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 py-4 bg-white rounded-lg shadow-xl">
            <div className="flex flex-col space-y-4 px-4">
              <a
                href="#benefits"
                onClick={(e) => handleNavClick(e, '#benefits')}
                className="font-medium py-2 hover:opacity-80 transition-opacity cursor-pointer"
                style={{ color: colors.primary }}
              >
                Benefits
              </a>

              <a
                href="#pricing"
                onClick={(e) => handleNavClick(e, '#pricing')}
                className="font-medium py-2 hover:opacity-80 transition-opacity cursor-pointer"
                style={{ color: colors.primary }}
              >
                Pricing
              </a>
              <a
                href="#testimonials"
                onClick={(e) => handleNavClick(e, '#testimonials')}
                className="font-medium py-2 hover:opacity-80 transition-opacity cursor-pointer"
                style={{ color: colors.primary }}
              >
                Testimonials
              </a>
              <a
                href="#faq"
                onClick={(e) => handleNavClick(e, '#faq')}
                className="font-medium py-2 hover:opacity-80 transition-opacity cursor-pointer"
                style={{ color: colors.primary }}
              >
                FAQ
              </a>
              <a 
                href="https://app.arbaah.ae/authentication/sign-in" 
                className="font-medium py-2 hover:opacity-80 transition-opacity"
                style={{ color: colors.primary }}
                onClick={() => setMobileMenuOpen(false)}
              >
                Login
              </a>
              <a 
                href="https://app.arbaah.ae/authentication/sign-up" 
                className="mt-2 px-4 py-2 rounded-full text-white font-medium hover:opacity-90 transition-opacity text-center"
                style={{ backgroundColor: colors.primary }}
                onClick={() => setMobileMenuOpen(false)}
              >
                Get Started
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;